<template>
    <div style="background-color: white;">
        <div class="logins_nav">
			<div>
				<img class="cursor" src="@/assets/image/bufanlogo.png" style="margin-right: 36px;" alt="" @click="toUrl('/')">
				欢迎登录
			</div>
			<div>
				<img src="@/assets/image/login_phone.png" alt="">
				0769-82810622
			</div>
        </div>
                 <!-- 微信支付方式 -->
        <div class="pop_payment" style="z-index:99;" v-if="wechatStauts" @click.stop>
            <div class="wechat_pay_main">
                <div class="ewm_login">
                    <div id="login_container"></div>
                </div>
                 <!-- <qrcode-vue :value="wechatText.pay_data" :size="200" level="H" /> -->
                <div class="off_wechat_pay" @click="wechatStautsBtn">
                    取消
                </div>
            </div>        
        </div>
		<div class="login_banner">
			<div class="logins_boxs" :class="{ verify_mode: active == 'sms' }">
				<div class="logins_right_bj">
					<div class="title">
						<div :class="active == item.value ? 'actives' : ''" v-for="item in options" :key="item.value"
							@click="loginStatusFun(item.value)">
							{{ item.label }}
						</div>
					</div>
					<template v-if="active == 'password'">
						<div class="login_form">
							<div class="logins_inputs">
								<!-- <div>
									<select v-model="value" class="selects" placeholder="Select" size="large">
										<option
										v-for="item in options"
										:key="item.value"
										:label="item.label"
										:value="item.value"
										></option>
									</select>
							</div> -->
								<div class="input_text">
									<input type="text" placeholder="请输入手机号" v-model="phone">
								</div>
								<div class="input_logo" @click="wordStatus">
									<img src="@/assets/image/peop.png" alt="">
								</div>
							</div>
							<div class="logins_inputs">
								<div class="input_texts">
									<input :type="wordtext" placeholder="请输入密码" v-model="passWord">
								</div>
								<div class="input_logo" @click="wordStatus">
									<img v-if="checked_status" src="@/assets/icon/faxiangengduo.png" alt="">
									<img v-if="!checked_status" src="@/assets/icon/请输入密码icon.png" alt="">
								</div>
							</div>
							<div class="logins_btn_submit" @click="loginFun">
								登  录
							</div>
							<div class="logins_text f12">
								<div style="text-align:right;width:100%;">
									<a @click="toUrl('/modify')"> 忘记密码？</a>
								</div>
							</div>
							<div class="logins_text">
								<div class="logins_register" @click.stop = "wechatStautsLogin">
									<img src="@/assets/icon/微信登录icon.png" alt="">
									<a>微信登录</a>
								</div>
								<div>
									<span>还没有账号？</span>&nbsp;&nbsp;
									<a @click="toRegister">免费注册</a>
								</div>
							</div>
						</div>
					</template>
					<template v-else>
						<div class="login_form verify_login_form">
							<div class="logins_inputs">
                                <div class="input_text"><input type="text" placeholder="请输入手机号" v-model="phone"></div>
                                <div class="input_logo">
									<img src="@/assets/image/peop.png" alt="">
								</div>
							</div>
							<div class="verify_login_row">
								<div class="verify_login_input sms_input">
									<input type="text" placeholder="请输入短信验证码" v-model="smsCode">
								</div>
								<button class="sms_code_btn" @click="getSmsCode" :disabled="!smsCodeStatus">
									{{ smsCodeStatus ? '获取验证码' : smsCountdown + 's' }}
								</button>
							</div>
							<button class="verify_login_submit" @click="loginFun">登录</button>
							<div class="logins_text f12 login_text_placeholder"></div>
							<div class="logins_text">
								<div class="logins_register" @click.stop = "wechatStautsLogin">
									<img src="@/assets/icon/微信登录icon.png" alt="">
									<a>微信登录</a>
								</div>
								<div>
									<span>还没有账号？</span>&nbsp;&nbsp;
									<a @click="toRegister">免费注册</a>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
		<div class="pop_box" v-if="loginWicth">
			<div class="pop_boxs">
				<div class="title">请选择登录的系统</div>
				<div class="btn_shop" @click.stop="router.push({ path: '/' })">登录不凡商城</div>
				<div class="btn_model" @click.stop="router.push({ path: '/model_home' })">登录选型中心</div>
			</div>
		</div>
		<!-- 尾部 -->
		<footers></footers>
    </div>
</template>

<style src="./login.css" scoped>

</style>

<script setup>
import QrcodeVue from 'qrcode.vue';
import axios from 'axios';
import { ref,reactive,watch,toRefs,getCurrentInstance,onMounted,onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { Toast, Dialog } from 'vant';
import { httpGet, httpPost, setAuthorization } from '@/utils/request';
import { useStore } from 'vuex';
import footers from '@/components/footer.vue';

const store = useStore();
const router = useRouter();
const noTokenRequest = axios.create({
    baseURL: axios.defaults.baseURL,
    timeout: axios.defaults.timeout,
    withCredentials: axios.defaults.withCredentials,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        platform: 'H5'
    }
});
const postWithoutToken = (url, data) => {
    const params = new URLSearchParams();
    Object.keys(data).forEach((key) => {
        params.append(key, data[key]);
    });
    return noTokenRequest.post(url, params).then(res => res.data);
}
const toUrl = function (url) {
    if(url.includes('?')){
        // 处理带参数的URL
        const [path, queryString] = url.split('?');
        const query = {};
        queryString.split('&').forEach(param => {
            const [key, value] = param.split('=');
            query[key] = value;
        });
        router.push({ path, query });
    }else{
        router.push({ path: url });
    }
};
const toRegister = () => {
    const query = {
        from: 'login'
    };
    if (active.value == 'sms' && phone.value) {
        query.mobile = phone.value;
    }
    router.push({
        path: '/register.html',
        query
    });
};
onMounted(() => {
    window.addEventListener('keydown', keyDown)
})
const keyDown = (e) => {
    console.log(e.keyCode)
  //如果是回车则执行登录方法
  if (e.keyCode == 13) {
    loginFun()
  }
}
onUnmounted(() => {
  window.removeEventListener('keydown', keyDown, false)
  clearInterval(smsTimer)
})


const passWord = ref(''); //登录密码
const phone = ref(''); //登录账户
const smsCode = ref('');
const smsCountdown = ref(60);
const smsCodeStatus = ref(true);
const mobileRegistered = ref(null);
let mobileCheckSeq = 0;
let smsTimer = null;

const isMobile = (value) => /^1[3-9]\d{9}$/.test(value);
const checkLoginMobileRegistered = (showTip = false) => {
    const mobile = phone.value;
    if (!isMobile(mobile)) {
        mobileRegistered.value = null;
        return Promise.resolve(false);
    }
    const seq = ++mobileCheckSeq;
    return httpPost('/api/user/checkUser', {
        mobile
    }).then((res) => {
        if (seq !== mobileCheckSeq) return false;
        const isUnregistered = res.code == 1 || res.data?.action == 'register';
        mobileRegistered.value = !isUnregistered;
        if (isUnregistered && showTip) {
            Toast('该手机号未注册，请先注册');
        }
        return !isUnregistered;
    }).catch(() => {
        if (seq === mobileCheckSeq) {
            mobileRegistered.value = null;
        }
        return false;
    })
}

watch(phone, (value) => {
    mobileRegistered.value = null;
    if (isMobile(value)) {
        checkLoginMobileRegistered(true);
    } else {
        mobileCheckSeq += 1;
    }
})

const getSmsCode = async () => {
    if (phone.value == '') return Toast('请输入手机号');
    if (!isMobile(phone.value)) return Toast('请输入正确的手机号');
    const registered = await checkLoginMobileRegistered(true);
    if (!registered) return;
    httpPost('/api/sms/feng_huo_send', {
        mobile: phone.value,
        event: 'mobilelogin'
    }).then((res) => {
        if (res.code == 0) {
            Toast(res.msg);
            return;
        }
        Toast(res.msg);
        smsCodeStatus.value = false;
        smsCountdown.value = 60;
        clearInterval(smsTimer);
        smsTimer = setInterval(() => {
            smsCountdown.value -= 1;
            if (smsCountdown.value <= 0) {
                clearInterval(smsTimer);
                smsCodeStatus.value = true;
                smsCountdown.value = 60;
            }
        }, 1000);
    })
}
// 登录密码显示
let wordtext = ref('password');//文本显示密码内容
let checked_status = ref(false);
const wordStatus = () => {
    checked_status.value = !checked_status.value;
    if (checked_status.value) {
        wordtext.value = 'text';
    } else {
        wordtext.value = 'password';
    }
};

// 开启微信登录状态
let wechatStauts = ref(false);
const wechatStautsBtn = () => {
    wechatStauts.value = false;
}
const wechatStautsLogin = () => {
    wechatStauts.value = true;
    wechatLogin()
}

// 微信登录
const wechatLogin = async () => {
      // 从后端获取appid以及重定向地址
        let { data, code } = await httpGet('api/user/getappid');
        let url = encodeURIComponent(`http://www.a-bf.cn/login/loginMiddle`)
        // console.log(url)
        if (code == 0) return
        // 官方文档提供的实例对象,具体参数说明可往下看
        var obj = new WxLogin({
            self_redirect: false,
            id: 'login_container',
            appid: data.appid, 
            scope: 'snsapi_login',
            // sandbox:"allow-scripts allow-top-navigation allow-same-origin",
            redirect_uri:url, // 这里跳的是扫码成功后,账户操作的地址   
            style: 'black', 
            state:200
        }) 
        
}


//登录方式
const active = ref('sms');
const loginStatusFun = (type) => {
    active.value = type
}

let loginWicth = ref(false)
const handleLoginSuccess = (res) => {
    const { data } = res
    const token = data.userinfo?.token || data.token;
    if (data.userinfo) {
        store.commit('updateUserInfo', data.userinfo)
    }
    store.commit('updateToken', token)
    setAuthorization(token)
    Toast(res.msg);

    // 登录成功后立即获取完整的用户信息
    const goAfterLogin = (userInfo = {}) => {
        if(userInfo.is_salesman==1){
            loginWicth.value = true
        }else{
            router.push({ path: '/' })
        }
    }
    httpPost('/api/User/getUserinfo', {}).then(userRes => {
        if (userRes.code == 1 && userRes.data) {
            store.commit('updateUserInfo', userRes.data)
            goAfterLogin(userRes.data)
            return;
        }
        goAfterLogin(data.userinfo)
    }).catch(() => {
        goAfterLogin(data.userinfo)
    })
}
//登录接口
const loginFun = (code) => {
	let data = {}
	if(typeof(code)!='string'){
		if (active.value == 'password') {
		    if(phone.value == '') return Toast('请输入手机号')
		    data.account = phone.value
		    data.password = passWord.value
		    if (data.password == '') return Toast('请输入密码')
		}
		if (active.value == 'sms') {
		    if(phone.value == '') return Toast('请输入手机号')
            if(smsCode.value == '') return Toast('请输入短信验证码')
            data.mobile = phone.value
            data.code = smsCode.value
            postWithoutToken('/addons/shopro/user/smsLogin', data).then(res => {
                if (res.code == 0) {
                    return Toast(res.msg);
                }
                if (res.code == 1) {
                    handleLoginSuccess(res);
                }
            })
            return;
		}
	}else{
		data.code = code
	}
    httpPost('/api/user/login', data).then(res => {
        const { data } = res
        console.log(data, 'data')
        if (res.code == 0) return Toast(res.msg);
        if (res.code == 1) {
            handleLoginSuccess(res);
        }
    })
    // Dialog.confirm({
    //     title: '确认登录'
    // }).then(() => {

    // })
    // .catch(() => {
    //     Toast('取消当前登录')
    // });
}
const getCode = () => {
	if(location.href.indexOf('code=')!=-1){
		loginFun(location.href.split('code=')[1])
	}
}
getCode()
const options = [
    {
        value: 'sms',
        label: '手机验证码登录',
    },
    {
        value: 'password',
        label: '账户密码登录',
    }
];
</script>
	<style scoped>
		#app{
			background-color: white !important;
		}
		body{
			background-color: white !important;
		}
		.logins_nav{
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 34px clamp(24px, 14vw, 367px) 20px;
			height: 107px;
			font-size: 20px;
			box-sizing: border-box;
		}
		.logins_nav div:nth-of-type(2){
			color: #BB0111;
			font-size: 24px;
		}
		.logins_nav div:nth-of-type(2) img{
			width: 58px;
			height: 58px;
		}
        @media (max-width: 1100px) {
            .logins_nav{
                padding: 24px 32px 14px;
                height: 92px;
                font-size: 18px;
            }
            .logins_nav div:nth-of-type(2){
                font-size: 20px;
            }
            .logins_nav div:nth-of-type(2) img{
                width: 46px;
                height: 46px;
            }
        }
        @media (max-width: 760px) {
            .logins_nav{
                padding: 18px 18px 12px;
            }
            .logins_nav div:nth-of-type(2){
                display: none;
            }
        }
	</style>
